'use client';

import React from 'react';

import { useAuthContext } from '@/components/Providers/AuthProvider';
import { useAppSelector } from '@/store';

// import { useGetFirstOrderBonusDetailsQuery } from '@/store/api/dashboard';

import ReportsLoader from '../Reports/CustomerDetailModal/ReportsLoader';
import VolumeBucketModels from '../Reports/VolumeBucketModals/VolumeBucketModels';
import CounterBox from './Components/CounterBox';

const FirstOrderBonusDetails = () => {
  const { customer } = useAuthContext();
  const customerId = customer?.customerID ?? 0;
  const firstOrderBonusData = useAppSelector(state => state.slices.dashboard.dashboardData?.firstOrderBonusData) || {};
  // const { data, isLoading, isFetching } = useGetFirstOrderBonusDetailsQuery();
  const isLoading = false;
  const isFetching = false;
  const data = { data: firstOrderBonusData };

  const [isModalOpen, setIsModalOpen] = React.useState(false);

  return (
    <div className="v2-shadow-md v2-p-[24px] md:v2-p-[24px] sm:v2-p-4 xs:v2-p-4 v2-bg-white v2-rounded-xs">
      <div className="v2-pb-5 v2-border-b v2-border-[#E5E5E5] v2-mb-5">
        <h2 className="v2-text-[#333333] v2-font-sweet-sans-pro-bold v2-font-bold v2-text-xl v2-text-center">
          First Order Bonus
        </h2>
      </div>
      {isLoading || isFetching ? (
        <div className="v2-h-[130px] v2-flex v2-justify-center v2-items-center">
          <ReportsLoader />
        </div>
      ) : (
        <div className="v2-flex v2-gap-3">
          <CounterBox
            label="FOB Order Count"
            count={data?.data.fobOrderCount ?? 0}
            onClick={() => setIsModalOpen(true)}
          />
          <CounterBox label="First Order Bonus" count={data?.data.fobBonus ?? 0.0} />
          <CounterBox label="FOB New PV" count={data?.data.fobNewPV ?? 0.0} />
        </div>
      )}

      <VolumeBucketModels
        modalOpen={isModalOpen}
        volumeBucketLabel="FOB Order Count"
        setModalOpen={() => setIsModalOpen(false)}
        customerId={customerId}
        volumeBucket={84}
        isTableView={false}
        selectedPeriodid={undefined}
      />
    </div>
  );
};

export default FirstOrderBonusDetails;
